// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, CircularProgress } from '@mui/material';

interface ComponentProps {
  showDialog: boolean;
  onOk: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onCancel: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  contentText: string;
  loading?: boolean;
}

export const ConfirmDialog: React.FC<ComponentProps> = ({ showDialog, onOk, onCancel, contentText, loading }) => (
  <Dialog
    open={showDialog}
    onClose={onCancel}
  >
    <DialogTitle>Are you sure?</DialogTitle>
    <DialogContent>{contentText}</DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button onClick={onOk} disabled={loading}>{ loading ? <CircularProgress size={20} /> : 'Ok' }</Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
